import React from "react";
import { HintRow } from "./ListEmptyShell";

/** What a models list shows until its first list lands: a spinner, or — with
 *  no connection to land it — the reason it isn't coming. */
export const ModelsLoading: React.FC<{ isOnline: boolean; label: string }> = ({
  isOnline,
  label,
}) => (
  <HintRow loading={isOnline}>
    {isOnline
      ? label
      : "You're offline — your models will appear when the connection restores"}
  </HintRow>
);
